<div class="modal-header" appCustomAutofocus style="background-color:#f5f5f5;">
    <h5 class="modal-title">Company Holidays</h5>
</div>
<div class="modal-body">
    <div class="row">
        <ng-select  class="col-lg-5"
                    [searchable]="false"
                    [clearable]="false"
                    [(ngModel)]="formData.selectedYear"
                    (change)="getHoliday()"
                    dropdownPosition="bottom">
                <ng-option *ngFor="let data of yearList" [value]="data.value">{{data.name}}</ng-option>
        </ng-select>
        <p class="col-lg-12"><quill-view [content]="modalMsg"></quill-view></p>
        <div class="col-lg-12" style="margin-top:15px;">
            <ng-container *ngIf="holidayList?.length > 0">
                <ul *ngFor="let data of holidayList">
                    <li style="list-style:none;">{{data.HolidayName}} - {{data.HolidayDateString}} ({{data.Day}})</li>
                </ul>
            </ng-container>
            <div *ngIf="holidayList?.length == 0">
                There are no company holidays in {{formData.selectedYear}}.
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">
        Close
    </button>
</div>